import React from 'react';
import { ApplicationView, StartControllerScope } from '@aha-app/mvc';
import AssistantViewController from './AssistantViewController';
import ControlledAssistantView from './ControlledAssistantView';

const AssistantView = () => {
  return <ControlledAssistantView />;
};

export default StartControllerScope(
  AssistantViewController,
  ApplicationView(AssistantView)
);
